import React, { useState, useEffect } from 'react'
// import { toast, ToastContainer } from 'react-toastify'
// import DatePicker from 'react-datepicker'

const Popup = props => {
  


  return (
    <>
      <button
        type='button'
        className='btn btn-info pull-right'
        onClick={() => props.closePopup()}
      >
        <span
          id='close'
          title='Close'
          className='glyphicon glyphicon-remove'
        ></span>
      </button>
      <form
        className='form form-horizontal'
        style={{
          width: '100%',
          height: 320,
          margin: '0 auto',
          background: '#fff',
          border: '1px solid #ccc',
          borderRadius: 10,
        }}
      >
        <h6 className='text-center'>{props.title}</h6>
        

        <div className='col-md-12'>
          {props.children}
 
        </div>
      </form>
    </>
  )
}

export default Popup
